












































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import Burger from "@/components/Burger.vue";
import axios from 'axios';

@Component({
    components: {Burger}
})
export default class NavBar extends Vue {
    private open = false;

    @Prop()
    isLoggedIn!: boolean;

    logout() {
        axios.post('/logout')
        .then(() => {
            window.location.href = '/';
        })
        .catch(() => {
            window.location.reload();
        })
    }

    get currentRouteName(): string {
        return window.location.pathname;
    }
}
